<mydocma-stepper
  [class.mydocma-mm-duplicate-stepper-mobile]="appContainerService.isMobileView"
  [class.mydocma-mm-duplicate-stepper-mobile-ios]="isMobileIOS"
  style="width: 100%;"
  [stepperConfig]="stepperConfig"
  (ready)="onReadyEvent($event)">
  
  <ng-template mydocmaStep="duplicateOptions" let-step="step">
    <mydocma-mm-duplicate-options mydocmaStepComponent
      [fault]="fault"
      [step]="step">
    </mydocma-mm-duplicate-options>
  </ng-template>
  
  <ng-template mydocmaStep="duplicateLocation" let-step="step">
    <mydocma-mm-duplicate-location mydocmaStepComponent
      [fault]="fault"
      [project]="project"
      [step]="step">
    </mydocma-mm-duplicate-location>
  </ng-template>
  
  <ng-template mydocmaStep="duplicateAttachments" let-step="step">
    <mydocma-mm-duplicate-attachments mydocmaStepComponent
      [fault]="fault"
      [step]="step">
    </mydocma-mm-duplicate-attachments>
  </ng-template>
</mydocma-stepper>